import { useScopeStore } from '../store'

export function useUpsellContext() {
  const isUpsell = useScopeStore((s) => s.scope.generalInfo.isUpsell) || false

  const incompleteClass = isUpsell ? '' : 'border-l-4 border-l-amber-400/60 pl-3'

  const mapLabel = (label: string) =>
    isUpsell && label.toLowerCase() === "don't know" ? 'Existing Settings' : label

  return { isUpsell, incompleteClass, mapLabel }
}
